import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import NumberFormat from "react-number-format"

import abiertoTitulo from '../../img/tabla/abiertoTitulo.svg'
import cerradoTitulo from '../../img/tabla/cerradoTitulo.svg'

import { iniChangeItemsInsideFromTitle, iniChangeTotales } from "../../../../redux/actions/pptos"
import { ItemsActions } from "../ItemsActions"
import { AutocompleteCategorias } from "../AutocompleteCategorias"
import { TablaPptosItems } from "./TablaPptosItems"
import { Tooltip } from "@mui/material"
import { DialogDetailItems } from "../DialogDetailItems"

export const TablaPptosTitle = ({ detailPtto, categories, separacion_miles, separacion_decimales, simbolo, services, detailPttos_, openAllSubTitles, openOrClosedSubtitleIsAll, index, placeholder, reading_mode, estado_negocio, unidadMedida, handleOpenListCompras }) => {

    const dispatch = useDispatch()

    const { access } = useSelector(state => state.auth)
    const [openSubTitles, setOpenSubTitles] = useState(true)

    const { ppto_items_mostrar_fechas, ppto_items_ocultar_dias, ppto_items_ocultar_dscto } = useSelector(state => state.general.detail)

    const { detail } = useSelector(state => state.ppto)
    const { margen_sobre_costo } = detail

    const [openDialogDetailItem, setOpenDialogDetailItem] = useState(false)

    useEffect(() => {
        setOpenSubTitles(openAllSubTitles)
    }, [openAllSubTitles])

    const hanldeChangeOpenSubtitle = () => {
        openOrClosedSubtitleIsAll(!openSubTitles)
        setOpenSubTitles(!openSubTitles)
    }

    const handleKey = (e, indexSubtitle_, indexTitle_, colum_, idTitulo_) => {
        //Solo ejecutar si presiona la tecla Enter   
        if (e.keyCode !== 13) return false

        let indexSubtitle;
        let indexTitle = indexTitle_;

        //buscar longitud subtitulos del titulo
        const filaActualTitle = detailPttos_.filter(item => (parseInt(item.id) === parseInt(idTitulo_)))

        if (filaActualTitle[0].items.length === (indexSubtitle_ + 1)) {
            //Pasar al siguiente titulo y primera fila
            indexTitle = (parseInt(indexTitle_) + 1)
            indexSubtitle = 0

        } else {
            //mantener en el mismo titulo y pasar a la siguiente fila
            indexSubtitle = (parseInt(indexSubtitle_) + 1)
        }

        const value = `${indexSubtitle}${indexTitle}${colum_}`
        const nextInput = document.getElementById(value)
        if (nextInput) {
            nextInput.focus()
        }
        return false
    }

    const handleChange = (values, target) => {
        if (!values.sourceInfo.event) return false

        const newParams = {
            items: detail.items,
            target,
            new_margen: values.floatValue,
            idTitulo: detailPtto.id,
            margen_sobre_costo
        }

        dispatch(iniChangeItemsInsideFromTitle(newParams))
        dispatch(iniChangeTotales(detail, detail.items, margen_sobre_costo))

    }

    return (
        <>

            {openDialogDetailItem &&
                <DialogDetailItems
                    open={openDialogDetailItem}
                    setOpen={setOpenDialogDetailItem}
                    item={detailPtto}
                />
            }

            <tr className="p-title">
                {!reading_mode &&
                    <td className="p-col-medium border-right-separate">
                        <div className="d-flex justify-content-between align-items-center">
                            <ItemsActions
                                item={detailPtto}
                                openSubTitles={openSubTitles}
                                hanldeChangeOpenSubtitle={hanldeChangeOpenSubtitle}
                                sorting={(detailPtto?.items.length)}
                            />
                        </div>
                    </td>
                }
                <td className="p-col-x-large sticky left-0 bg-white z-10 px-4 py-2 border">
                    <div className="AutocompleteListTitle d-flex justify-content-between align-items-center">
                        {openSubTitles ?
                            <img
                                onClick={hanldeChangeOpenSubtitle}
                                role='button'
                                className='icon-abrir p-1'
                                src={abiertoTitulo}
                                alt='abierto'
                                title='Cerrar sub items'
                            />
                            :
                            <img
                                onClick={hanldeChangeOpenSubtitle}
                                role='button'
                                className='icon-cerrar p-1'
                                src={cerradoTitulo}
                                alt='cerrado'
                                title='Abrir sub items'
                            />
                        }
                        <div className="CantSubTitlesPpto">
                            {detailPtto?.items.length}
                        </div>
                        <AutocompleteCategorias
                            itemsOptions={categories}
                            item={detailPtto}
                        />
                        {(detailPtto.nombre !== null && detailPtto.nombre !== '') &&
                            <Tooltip title="Detalle servicio">
                                <i
                                    style={{
                                        cursor: 'pointer',
                                        color: (detailPtto.descripcion_larga && detailPtto.descripcion_larga !== '') ? '#8E24AA' : '',
                                        fontSize: '12px',
                                        marginLeft: '10px'
                                    }}
                                    data-bs-toggle="tooltip"
                                    ata-bs-placement="top"
                                    data-bs-title="Tooltip on top"
                                    className="bi bi-card-text"
                                    onClick={() => setOpenDialogDetailItem(true)}
                                ></i>
                            </Tooltip>
                        }
                    </div>
                </td>

                {/* cant */}
                <td className="p-col-small"></td>

                {/* dias */}
                {!ppto_items_ocultar_dias && <td className="p-col-small"></td>}

                {/* unidad */}
                <td className="p-col-small"></td>

                {/* precio_unitario */}
                <td className="p-col-medium"></td>

                {/* pre_subtotal_precio */}
                {!ppto_items_ocultar_dscto &&
                    <td className="p-col-medium text-end">
                        <NumberFormat
                            className='cantidades-title-new'
                            value={detailPtto.pre_subtotal_precio}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale
                        />
                        <Tooltip title="valor calculado, no modificable">
                            <i className="bi bi-lock p-icon-block"></i>
                        </Tooltip>
                    </td>
                }

                {/* -- dscto --- */}
                {!ppto_items_ocultar_dscto &&
                    <td className="p-col-medium text-end">
                        <NumberFormat
                            className='cantidades-title-new'
                            value={detailPtto.descuento}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale
                        />
                        <Tooltip title="valor calculado, no modificable">
                            <i className="bi bi-lock p-icon-block"></i>
                        </Tooltip>
                    </td>
                }

                {/* precio_subtotal */}
                <td className='p-col-medium border-right-separate text-end'>
                    <NumberFormat
                        className='cantidades-title-new'
                        value={detailPtto.precio_subtotal}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        prefix={`${simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale
                    />
                    <Tooltip title="valor calculado, no modificable">
                        <i className="bi bi-lock p-icon-block"></i>
                    </Tooltip>
                </td>

                {/* costo_unitario */}
                {access.a20 &&
                    <td className="p-col-medium"></td>
                }

                {/* costo_subtotal */}
                {access.a20 &&
                    <td className='p-col-medium border-right-separate text-end'>
                        <NumberFormat
                            className='cantidades-title-new'
                            value={detailPtto.costo_subtotal}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale
                        />
                        <Tooltip title="valor calculado, no modificable">
                            <i className="bi bi-lock p-icon-block"></i>
                        </Tooltip>
                    </td>
                }

                {/* margen_monto */}
                {access.a21 &&
                    <td className="p-col-medium text-end">
                        <NumberFormat
                            className='cantidades-title-new'
                            value={detailPtto.margen_monto}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale
                        />
                        <Tooltip title="valor calculado, no modificable">
                            <i className="bi bi-lock p-icon-block"></i>
                        </Tooltip>
                    </td>
                }

                {/* margen_porcentaje */}
                {access.a21 &&
                    <td className="p-col-small border-right-separate text-end">
                        {/* <NumberFormat
                            className='cantidades-title-new'
                            value={detailPtto.margen_porcentaje}
                            displayType={'text'}
                            suffix=" %"
                            decimalScale={2}
                            fixedDecimalScale
                        />
                        <Tooltip title="valor calculado, no modificable">
                            <i className="bi bi-lock p-icon-block"></i>
                        </Tooltip> */}

                        <NumberFormat
                            className='p-cantidades-item-new'
                            value={detailPtto.margen_porcentaje}
                            suffix="%"
                            // onKeyDown={(e) => handleKey(e, index, indexTitle, 'margen_porcentaje', detailPtto.id)}
                            // id={`${index}${indexTitle}margen_porcentaje`}
                            onValueChange={(values, sourceInfo) => handleChange({ ...values, sourceInfo }, 'margen_porcentaje')}
                            disabled={reading_mode}
                            decimalScale={2}
                            fixedDecimalScale
                        />
                    </td>
                }

                {/* modo negocio - actual */}
                {estado_negocio === 'aprobado' &&
                    <>
                        {access.a22 &&
                            <>
                                <td className='p-col-medium text-end border-right-separate'>
                                    <NumberFormat
                                        className='cantidades-title-new'
                                        value={detailPtto.total_gasto_real || 0}
                                        displayType={'text'}
                                        thousandSeparator={separacion_miles}
                                        decimalSeparator={separacion_decimales}
                                        prefix={`${simbolo} `}
                                        decimalScale={2}
                                        fixedDecimalScale
                                    />
                                    <Tooltip title="valor calculado, no modificable">
                                        <i className="bi bi-lock p-icon-block"></i>
                                    </Tooltip>
                                </td>
                                <td className='p-col-medium text-end bg-col-pg border-right-separate'>
                                    <NumberFormat
                                        className='cantidades-title-new'
                                        value={detailPtto.total_por_gastar || 0}
                                        displayType={'text'}
                                        thousandSeparator={separacion_miles}
                                        decimalSeparator={separacion_decimales}
                                        prefix={`${simbolo} `}
                                        decimalScale={2}
                                        fixedDecimalScale
                                    />
                                    <Tooltip title="valor calculado, no modificable">
                                        <i className="bi bi-lock p-icon-block"></i>
                                    </Tooltip>
                                </td>
                                <td className='p-col-small text-end bg-col-pg border-right-separate'>
                                    <NumberFormat
                                        className='cantidades-title-new'
                                        value={detailPtto.margen_por_gastar || 0}
                                        displayType={'text'}
                                        suffix=" %"
                                        decimalScale={2}
                                        fixedDecimalScale
                                    />
                                    <Tooltip title="valor calculado, no modificable">
                                        <i className="bi bi-lock p-icon-block"></i>
                                    </Tooltip>
                                </td>
                            </>
                        }

                        {access.a23 &&
                            <>
                                <td className='p-col-medium text-end bg-col-pg border-right-separate'>
                                    <NumberFormat precio_subtotal
                                        className='cantidades-title-new'
                                        value={detailPtto.total_utilidad_real || 0}
                                        displayType={'text'}
                                        thousandSeparator={separacion_miles}
                                        decimalSeparator={separacion_decimales}
                                        prefix={`${simbolo} `}
                                        decimalScale={2}
                                        fixedDecimalScale
                                    />
                                    <Tooltip title="valor calculado, no modificable">
                                        <i className="bi bi-lock p-icon-block"></i>
                                    </Tooltip>
                                </td>
                                <td className='p-col-small text-end bg-col-pg border-right-separate'>
                                    <NumberFormat
                                        className='cantidades-title-new'
                                        value={detailPtto.margen_utilidad_real || 0}
                                        displayType={'text'}
                                        suffix=" %"
                                        decimalScale={2}
                                        fixedDecimalScale
                                    />
                                    <Tooltip title="valor calculado, no modificable">
                                        <i className="bi bi-lock p-icon-block"></i>
                                    </Tooltip>
                                </td>
                            </>
                        }

                    </>
                }

                {ppto_items_mostrar_fechas &&
                    <>
                        <td className="text-center bg-col-fechas border-right-separate">--</td>
                        <td className="text-center bg-col-fechas border-right-separate">--</td>
                    </>
                }

                {/* seleccionar */}
                <td className="text-center p-col-small"></td>

            </tr>

            {openSubTitles && detailPtto.items?.map((subDetailPpto, i) => {
                return (
                    <TablaPptosItems
                        key={subDetailPpto.id}
                        subDetailPpto={subDetailPpto}
                        index={i}
                        indexTitle={index}
                        handleKey={handleKey}
                        estado_negocio={estado_negocio}
                        unidadMedida={unidadMedida}
                        handleOpenListCompras={handleOpenListCompras}
                    />
                )
            })}

        </>
    )
}